import { Box, chakra, useRadio, UseRadioProps } from '@chakra-ui/react';

type RecipeRadioValue = {
  value: string;
  label: string;
};

type RecipeListRadioProps = Omit<RecipeRadioValue, 'value'> & UseRadioProps;

export function RecipeListRadio({ label, ...props }: RecipeListRadioProps) {
  const { state, getInputProps, getCheckboxProps, htmlProps, getLabelProps } =
    useRadio(props);

  return (
    <chakra.label cursor="pointer" {...htmlProps}>
      <input {...getInputProps()} hidden />
      <Box
        whiteSpace="nowrap"
        position="relative"
        rounded="lg"
        px="4"
        py="1"
        border="1px solid"
        {...getCheckboxProps()}
        bg={state.isChecked ? '#0000A310' : 'white'}
        borderColor={state.isChecked ? 'blue' : 'gray.75'}
        color={state.isChecked ? 'blue' : 'gray.75'}
      >
        <Box fontSize="md" textAlign="center" {...getLabelProps()}>
          {label}
        </Box>
      </Box>
    </chakra.label>
  );
}
